import axios, { AxiosError } from 'axios';
import config from '../../config/config';





/// 管理員取得資料
/// api/EpAdmin/list
export const getEpAdminGroupList = async () => {
    const url = config.server.url + `/api/EpAdmin/list`;

    return new Promise((resolve, reject) => {
        axios
            .get(url)
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
                reject(error); //
            });
    });
};


